"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactSegmentWrapper = void 0;
const tracking_client_1 = require("@sparefoot/tracking-client");
const analytics_next_1 = require("@segment/analytics-next");
const errors_1 = require("./errors");
class ReactSegmentWrapper {
    constructor(options) {
        this.siteId = options.siteId;
        this.visitId = options.visitId;
        this.environment = options.environment || "development";
        this.debug = options.debug || false;
        // error if a siteID or visitID is not provided
        if (!this.visitId) {
            throw new errors_1.ReactSegmentWrapperError(errors_1.ErrorMessage.MISSING_VISIT_ID);
        }
        // error if a siteID is not provided
        if (!this.siteId) {
            throw new errors_1.ReactSegmentWrapperError(errors_1.ErrorMessage.MISSING_SITE_ID);
        }
        if (!ReactSegmentWrapper.isBrowser()) {
            throw new errors_1.ReactSegmentWrapperError(errors_1.ErrorMessage.NOT_BROWSER);
        }
        // Create segment settings with required writeKey
        const segmentSettings = {
            writeKey: options.writeKey,
            cdnURL: options.cdnURL,
        };
        // Create segment options with optional integrations
        const segmentOptions = {
            integrations: options.integrations,
        };
        this.analytics = analytics_next_1.AnalyticsBrowser.load(segmentSettings, segmentOptions);
    }
    static isBrowser() {
        return typeof window !== "undefined";
    }
    logSegmentEvent(event, properties) {
        if (this.debug) {
            console.debug(`[Segment] ${event}`, properties);
        }
    }
    appendDefaultProperties(properties) {
        return {
            ...properties,
            siteId: this.siteId,
            visitId: this.visitId,
            environment: this.environment,
            timestamp: new Date().toISOString(),
        };
    }
    /**
     * trackSegment is a private method that tracks an event using the Segment SDK.
     * It should not be called directly. Instead, use the public methods below.
     */
    track(eventName, properties) {
        const enrichedProperties = this.appendDefaultProperties(properties);
        this.analytics.track(eventName, enrichedProperties);
        this.logSegmentEvent(tracking_client_1.SegmentEventType.Track, {
            eventName,
            enrichedProperties,
        });
    }
    /**
     * pageViewSegment is a private method that tracks a page view using the Segment SDK.
     * It should not be called directly. Instead, use the public methods below.
     */
    pageView(pageType, name, properties = {}) {
        const enrichedProperties = this.appendDefaultProperties(properties);
        this.analytics.page(pageType, name, enrichedProperties);
        this.logSegmentEvent(tracking_client_1.SegmentEventType.PageView, {
            pageType,
            name,
            enrichedProperties,
        });
    }
    /**
     * identifySegment is a private method that identifies a user using the Segment SDK.
     * It should not be called directly. Instead, use the public methods below.
     */
    identify(traits) {
        this.analytics.identify(this.visitId, traits);
        this.logSegmentEvent(tracking_client_1.SegmentEventType.Identify, {
            userId: this.visitId,
            traits,
        });
    }
}
exports.ReactSegmentWrapper = ReactSegmentWrapper;
//# sourceMappingURL=ReactSegmentWrapper.js.map